import React from 'react'
import Loading from "../../components/common/Loading";
import switchStyles from "../../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import Bakers from '@/components/outlet/Bakers';

const bakersConfectioners = () => {
  return (
    <>
      <Head>
        <title>Hassle-Free Bakery Management with QB Bakery Billing Software</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/bakers-confectioners" />
        <link rel="alternate" href="https://queuebuster.co/outlet/bakers-confectioners" hrefLang="en-us" />
        <meta name="description" content="Simplify your bakery's operations with QueueBuster POS. From rapid billing to online orders and financial reporting, QB helps you manage your business efficiently." />
        <meta property="og:title" content="Streamline Your Bakery with QB Bakery Billing Software for Fast Billing & Seamless Management." />
        <meta property="og:description" content="QB Bakery Billing Software offers an easy-to-use system for bakery and cafe management. Enjoy rapid billing, food delivery integration, automated financial reporting, and third-party API compatibility to streamline your operations and boost efficiency." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG%2BImages%2Bwebsite%2Bpages-03.jpg" />
        <meta property="og:url" content="https://queuebuster.co/outlet/bakers-confectioners" />
      </Head>
         <SchemaTags page="bakers-confectioners" />
      <Bakers />
    </>
  )
}

export default bakersConfectioners